/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CheckFundExhaustedResponse
 *
 * @class CheckFundExhaustedResponse
 */
class CheckFundExhaustedResponse {
  /**
   * Creates an instance of CheckFundExhaustedResponse.
   * @param {*} json
   * @memberof CheckFundExhaustedResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isExhausted = json.isExhausted;
    }
  }
}

export default {
  CheckFundExhaustedResponse,
};
